module.exports = __webpack_public_path__ + "8cdf0d9b7aa621adf8e8841a951452f2.pdf";